define((require) => {
    var _                 = require("underscore"),
        AbstractRulerView = require("ui/editor/ruler/AbstractRulerView");

    /**
     *
     * @param {ExperienceModel} model The active experience.
     */
    return AbstractRulerView.extend({

        SPACING_CSS_PROPERTY: "margin-left",

        DISTANCE_CSS_PROPERTY: "left",

        className: "horizontal",

        // The mousedown event is not triggered if defined in AbstractRulerView.
        events: {
            "mousedown": "_onMouseDown"
        },

        /**
         * Renders the ruler for a given scene number
         * @param {Number} width
         * @param {Object} renderOptions @see AbstractRulerView#getDefaultRenderOptions
         */
        render: function(width, renderOptions) {
            renderOptions = _.extend(this.getDefaultRenderOptions(), renderOptions);

            var $ruler = this._createRuler(width, renderOptions.scale);

            $ruler.find(this.MAJOR_INCREMENT_SELECTOR + "," + this.SUB_INCREMENT_SELECTOR).addClass("pull-left");

            this.$el.html($ruler);
            this.setDistanceToStart(renderOptions.marginAtStartPx);

            // Add 30 px to get the ruler to continue outside the scene because it looks better.
            $ruler.width(width + 30);

            this.$el.removeClass("hidden");
        },

        /**
         * @returns {Number} distance from the start in pixels
         */
        getDistanceToStart: function() {
            var spacingCssString = this.$el.find(".ruler-elements-list").css(this.SPACING_CSS_PROPERTY);
            return parseInt(spacingCssString.replace("px", ""), 10);
        },

        /**
         * @param {Number} marginAtStartPx margin at the start of the ruler in pixels
         */
        setDistanceToStart: function(marginAtStartPx) {
            this.$el.find(".ruler-elements-list").css(this.SPACING_CSS_PROPERTY, marginAtStartPx);
        },

        _onMouseDown: function(mouseDownEvent) {
            this.trigger("guideline:add", mouseDownEvent);
            return false;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ruler/HorizontalRulerView.js